import React from "react";
import { Query } from "@apollo/client/react/components";
import { gql } from "@apollo/client";
import type { UploadFile } from "antd";
import PageLoader from "../PageLoader";
import { MigrationFileUploader } from "../MigrationFileUploader";
import {
  removeFileFromMigration,
  addFileToMigration,
} from "../../lib/migrationFiles";

const MIGRATION_FILES_QUERY = gql`
  query MigrationRunQuery($migrationId: ID!) {
    migration(id: $migrationId) {
      id
      name
      files {
        id
        filename
        url
        updatedAt
      }
    }
  }
`;

type MigrationFilesProps = {
  dataMigrationId: string | number;
};

export class MigrationFiles extends React.Component<MigrationFilesProps> {
  onFileRemoved = (file: UploadFile<any>, files: any[]) => {
    const matchingFile = files.filter((f) => f.filename === file.name)[0];
    if (matchingFile) {
      removeFileFromMigration(matchingFile.id, matchingFile.filename, [
        {
          query: MIGRATION_FILES_QUERY,
          variables: { migrationId: this.props.dataMigrationId },
        },
      ]);
    }
  };

  onUploadComplete = (file: UploadFile<any>) => {
    addFileToMigration(this.props.dataMigrationId, file.name, file.url, [
      {
        query: MIGRATION_FILES_QUERY,
        variables: { migrationId: this.props.dataMigrationId },
      },
    ]);
  };

  render() {
    return (
      <Query
        query={MIGRATION_FILES_QUERY}
        variables={{ migrationId: this.props.dataMigrationId }}
        pollInterval={2000}
      >
        {({ loading, data }) => {
          if (loading) return <PageLoader tip="Loading..." delay={500} />;

          const files: any[] = data.migration.files || [];

          return (
            <MigrationFileUploader
              defaultFiles={files}
              onFileRemoved={(file) => this.onFileRemoved(file, files)}
              onUploadComplete={this.onUploadComplete}
            />
          );
        }}
      </Query>
    );
  }
}
